export default __webpack_public_path__ + "static/media/1995.a27211fb.png";